import { Group } from '@ekhodealer/ekho-common/rev';

import type { PreQualificationStatus } from '@ekhodealer/ekho-common';

import { PrequalBadge } from '../PrequalBadge';

interface PrequalCellProps {
	prequalStatus: PreQualificationStatus | undefined;
}

export const PrequalCell = ({ prequalStatus }: PrequalCellProps) => (
	<Group itemsAlignX='center' noWrap>
		<PrequalBadge status={prequalStatus} />
	</Group>
);
